import { render, staticRenderFns } from "./ExternalChoseAddressPage.vue?vue&type=template&id=3e662f90&"
import script from "./ExternalChoseAddressPage.vue?vue&type=script&lang=ts&"
export * from "./ExternalChoseAddressPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports